import { PasswordViewToggleDirective } from './password-view-toggle.directive';
import { NgModule } from '@angular/core';


@NgModule({
  declarations: [PasswordViewToggleDirective],
  exports: [PasswordViewToggleDirective],
})
export class PasswordViewToggleModule { }
